import { render } from "./PanoVideo.vue?vue&type=template&id=5aa0133e"
import script from "./PanoVideo.vue?vue&type=script&lang=js"
export * from "./PanoVideo.vue?vue&type=script&lang=js"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__